import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { msRedirectVerarbeiten } from './msalClient';

const ACCOUNT_KEYS = { kalender: 'kalender_ms_account_id', posteingang: 'posteingang_ms_account_id' };

msRedirectVerarbeiten(ACCOUNT_KEYS).then((wirdNeuGeladen) => {
  if (wirdNeuGeladen) return;
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <App />
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
